/**
 * Runs `worker` over `items` with at most `limit` in flight at once.
 * Prevents bursts like "select all 23 apartments and delete" from firing
 * 100+ concurrent DB operations against a connection pool sized for far fewer.
 *
 * Returns results in the same order as `items` (like Promise.all).
 */
export async function runWithConcurrencyLimit(items, worker, limit = 3) {
  const results = new Array(items.length);
  let nextIndex = 0;

  async function runNext() {
    while (nextIndex < items.length) {
      const currentIndex = nextIndex++;
      results[currentIndex] = await worker(items[currentIndex], currentIndex);
    }
  }

  const workers = Array.from({ length: Math.min(limit, items.length) }, runNext);
  await Promise.all(workers);

  return results;
}
